import DivContainerBody from '../../../../../components/DivContainerBody';
import CustomExpandableTable from '../../../../../components/table/CustomExpandableTable';
import HeadTittle from '../../../../../components/HeadTittle';
import React from 'react';
import EmployeeCardGrid from '../../../Employee/SubComponents/EmployeeCardGrid';
import EmployeeDetailsDocumentationApp
    from '../../Functionality/EmployeeDetailsFlows/EmployeeDetailsDocumentationApp';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const EmployeeDetailsDocumentation = (
    {
        userType
    }
) => {

    const {
        t,
        handleRowExpand,
        columns,
        sections,
        renderExpandedRow,
        goBack,
        elementDetails
    } = EmployeeDetailsDocumentationApp({ userType });

    return (
        <>
            <HeadTittle name={t('details')} onBack={goBack} />
            <DivContainerBody>
                <div className='row px-0 pb-5'>
                    <div className='col-sm-12 col-md-4 col-lg-3 px-0'>
                        <EmployeeCardGrid elementDetails={elementDetails} />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-9 pl-0'>
                        <CustomExpandableTable
                            columns={columns}
                            rows={sections}
                            checkbox={false}
                            rowsPerPage={sections.length}
                            selectedList={[]}
                            handleCheckboxChange={() => { }}
                            handleDeleteAll={() => { }}
                            renderExpandedRow={renderExpandedRow}
                            renderOptionsMenu={null}
                            onRowExpand={handleRowExpand}
                            tooltip={false}
                            showHeader={false}
                            withoutHeight={true}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
}

export default EmployeeDetailsDocumentation;
